<template>
  <ul class="menu">
    <li class="parent" v-for="navigation in getSelectedRegionNavigation" :key="navigation.name">
      <a>{{navigation.name}}</a>
      <ul class="children">
        <li v-for="option in navigation.options" :key="option.name" >
          <a @click="writeChosenNavigationOptionToStore(option)">{{option.name}}</a>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
import {mapMutations} from "vuex";

export default {
  name: "DropdownButton",
  props: ["buttonType", "buttonName"],
  computed: {
    getSelectedRegionNavigation() {
      return this.$store.getters.getSelectedRegion.navigation;
    },
  },
  methods: {
    writeChosenNavigationOptionToStore(navigationOptions) {
      this.assignSelectedNavigationOption(navigationOptions);
    },
    ...mapMutations(["assignSelectedNavigationOption"]),
  },
};
</script>

<style lang="scss" scoped>
@import "../../sass/_variables.scss";

.menu {
  display: inline-block;
  list-style-type: none;
  margin: 4rem auto 0;

  a {
    display: block;
    margin: 0;
    padding: 1.6rem 2.5rem;
    color: white;
    text-decoration: none;
    background-image: linear-gradient(
            to right bottom,
            $color-primary-light,
            $color-primary-dark
    );
    font-size: 1.5rem;
    border-radius: 1rem;
    box-shadow: rgba(0, 0, 0, 0.3) 0rem 1.9rem 3.8rem, rgba(0, 0, 0, 0.22) 0px 15px 12px;
  }

  li {
    position: relative;
    float: left;
    margin: 0;
    margin-left: 1rem;
    perspective: 200;

    &:first-child {
      border-left: none;
    }
    &.parent {
      &:before {
        content: '';
        z-index: 200;
        position: absolute;
        top: 100%;
        left: 50%;
        margin-top: -.4rem;
        margin-left: -2rem;
        display: block;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: .8rem 2rem 0 2rem;
        border-color:  transparent transparent transparent;
        transition: margin-top .1s ease-out;
      }
    }
    &:hover,
    &:focus {
      & > a {
        text-decoration: none;
        color: $color-secondary;
        cursor: pointer;
      }
      &:before {
        margin-top: 0;
        border-top-color: $color-secondary;
      }
      .children {
        opacity: 1;
        transform: rotateX(0) translateZ(0);
      }
    }
  }
  .children {
    opacity: 0;
    backface-visibility: hidden;
    transform: rotateX(-90deg);
    transform-style: preserve-3d;
    transform-origin: top center;
    transition: transform .4s cubic-bezier(.17,.67,.59,1.21), opacity .1s .1s;

    z-index: 100;
    list-style-type: none;
    position: absolute;
    top: 100%;
    left: 0;
    width: 20rem;
    margin: 0;
    padding: 1rem 0;
    box-shadow: 0 .2rem .3rem 0 rgba(0,0,0,0.1);
    text-align: left;

    li {
      float: none;
      margin: 0;
    }
    a {
      background-color: transparent;
      border-radius: 0;
      font-size: 1.2rem;

      &:hover,
      &:focus {
        color: $color-secondary;
        background-color: #f9f9f9;
        cursor: pointer;
      }
    }
  }
}

.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}
body {
  background-color: #584E4A;
  text-align: center;
}

</style>
